import clsx from 'clsx';
import type { Range } from '@/lib/admin-types';

export type RangePickerProps = {
  value: Range;
  onChange: (r: Range) => void;
  options?: Range[];
};

const DEFAULT_OPTIONS: Range[] = ['7d', '30d', '90d'];

export function RangePicker({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
}: RangePickerProps) {
  return (
    <div className="inline-flex rounded-xl border border-gray-200 bg-white p-0.5 shadow-sm">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          onClick={() => onChange(opt)}
          className={clsx(
            'rounded-lg px-3 py-1.5 text-sm font-medium transition-colors',
            value === opt
              ? 'bg-primary text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
          )}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
